var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2LeasingSprzetuIMaszyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffcf5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #bec6c6;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-4 {\n        fill: #ffa900;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,7h4s0,4,0,4c0,1.1-.9,2-2,2-.81,0-2-.63-2-2v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3,14c-1.65,0-3-1.35-3-3v-4c0-.55.45-1,1-1h4c.55,0,1,.45,1,1v4c0,1.65-1.35,3-3,3Zm-1-6v3c0,.55.45,1,1,1s1-.45,1-1v-3h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41,13v16H3V13c0-1.1.9-2,2-2h34c1.1,0,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3,
    y: 29,
    width: 38,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5,
    y: 33,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17,
    y: 33,
    width: 22,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25,
    y: 1,
    width: 14,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29,
    y: 7,
    width: 6,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41,34H3c-.55,0-1-.45-1-1V13c0-1.65,1.35-3,3-3h34c1.65,0,3,1.35,3,3v20c0,.55-.45,1-1,1Zm-37-2h36V13c0-.55-.45-1-1-1H5c-.55,0-1,.45-1,1v19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26,
    y: 14,
    width: 12,
    height: 4,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9,11h-4v-6c0-1.1.9-2,2-2,.81,0,2,.63,2,2v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21,5v11s-12,0-12,0V5c0-1.09-.89-2-2-2h12c1.1,0,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17,12h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17,8h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m21,17h-12c-.55,0-1-.45-1-1V6c0-.55.45-1,1-1s1,.45,1,1v9h10V5c0-.55-.45-1-1-1H7c-.55,0-1-.45-1-1s.45-1,1-1h12c1.65,0,3,1.35,3,3v11c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m9,12h-4c-.55,0-1-.45-1-1v-6c0-1.65,1.35-3,3-3s3,1.35,3,3v6c0,.55-.45,1-1,1Zm-3-2h2v-5c0-.55-.45-1-1-1s-1,.45-1,1v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m23,17H7c-.55,0-1-.45-1-1s.45-1,1-1h16c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m39,8h-14c-.55,0-1-.45-1-1V1c0-.55.45-1,1-1h14c.55,0,1,.45,1,1v6c0,.55-.45,1-1,1Zm-13-2h12V2h-12v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m35,12h-6c-.55,0-1-.45-1-1v-4c0-.55.45-1,1-1h6c.55,0,1,.45,1,1v4c0,.55-.45,1-1,1Zm-5-2h4v-2h-4v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41,46H3c-.55,0-1-.45-1-1s.45-1,1-1h38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m39,46H5c-.55,0-1-.45-1-1v-12c0-.55.45-1,1-1h34c.55,0,1,.45,1,1v12c0,.55-.45,1-1,1Zm-33-2h32v-10H6v10Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29,
    y: 34,
    width: 6,
    height: 8,
    transform: "translate(64 76) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 34,
    width: 6,
    height: 8,
    transform: "translate(48 76) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24,37c-.55,0-1-.45-1-1v-3c0-.55.45-1,1-1s1,.45,1,1v3c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m32,37c-.55,0-1-.45-1-1v-3c0-.55.45-1,1-1s1,.45,1,1v3c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11,
    cy: 39,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17,46c-.55,0-1-.45-1-1v-12c0-.55.45-1,1-1s1,.45,1,1v12c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36,26h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30,26h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36,22h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30,22h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16,26h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10,26h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16,22h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22,26h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22,22h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10,22h-2c-.55,0-1-.45-1-1s.45-1,1-1h2c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m41,30H3c-.55,0-1-.45-1-1s.45-1,1-1h38c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2LeasingSprzetuIMaszyn);
export default __webpack_public_path__ + "static/media/2-Leasing-sprzetu-i-maszyn.e5ff23e9ade029c9be9bc91786cc2a0f.svg";
export { ForwardRef as ReactComponent };